import * as React from 'react';
import { flow, forEach, get, head, map } from 'lodash';
import { FieldArray, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { IMtaActions, IMtaFormNames, IMtaState, PageForm } from '../../../../../../../../services/mta/models';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { mtaActions } from '../../../../../../../../services/mta/actions';
import { actions as brandingActions } from '../../../../../../../../services/branding/reducer';
import { IOptionMap, ITraveller } from '../../../../../../../../data/api/models';
import { IBrandingActions, II18nMessages } from '../../../../../../../../services/branding/models';
import { Button, Form, Grid } from 'react-bootstrap';
import MTATravellers from '../Components/MTATravellers';
import { renderProductDefinition } from '../../../../Helpers';
import { MTAButtons } from '../../../MTAButtons';
import QuoteIcons from '../../../../../Components/Icon/QuoteIcons';
import { isAdult, isChild, isDobAFutureDate, isGroupChild } from '../../../../../../../../util/validators';
import { Link } from 'react-router-dom';
import { parse } from 'date-fns';

interface IMTAAdditionalTravellersFormProps extends InjectedFormProps<any> {
  options: IOptionMap;
  mta: IMtaState;
  i18n: II18nMessages;
  formValues: any;
  visibility: { options: any };
  tripType: string;
  selectedPolicy: any;
  groupType: string;
  travellers: ITraveller[];
  actions: {
    branding: IBrandingActions;
    mta: IMtaActions
  };
  disableButtons?: (disable: boolean) => any

  renderDefinition(name: string, useProvidedString?: boolean): any;
}

class MTAAdditionalTravellersForm extends React.Component<IMTAAdditionalTravellersFormProps, any> {
  constructor(props) {
    super(props);
    const { change } = props;
    change('page', PageForm.MTA_ADDITIONAL_TRAVELLERS);
    change('addingTravellers', true);
    window.scrollTo(0, 0);
    this.setTravellerDobSeparate()
    this.state = {
      showTravellers: false,
    };
  }

  public handleSubmit = () => {
    const { actions } = this.props;
    actions.mta.handleMTASubmit();
  }

  private setTravellerDobSeparate = () => {
    const { travellers, change } = this.props;
    forEach(travellers, (traveller, index) => {
      const dobDate = parse(traveller.dob, 'dd/MM/yyyy', new Date());
      const day = dobDate.getDate();
      const month = dobDate.getMonth() + 1;
      const year = dobDate.getFullYear();
      change(`data.attributes.travellers[${index}].dobSeparate.day`, day)
      change(`data.attributes.travellers[${index}].dobSeparate.month`, month)
      change(`data.attributes.travellers[${index}].dobSeparate.year`, year)
    })
  }

  private allowedGroupTypes = (name, key) => {
    const { selectedPolicy } = this.props;
    const originalGroupType = selectedPolicy.metadata.traveller_group;
    // originalGroupType = 'family_one_adult';
    if (originalGroupType === 'individual') {
      return this.renderGroupTypes(name, key);
    } else if (originalGroupType === 'family') {
      if (key === 'family' || key === 'group') {
        return this.renderGroupTypes(name, key);
      }
    } else if (originalGroupType === 'couple') {
      if (key === 'family' || key === 'couple' || key === 'group') {
        return this.renderGroupTypes(name, key);
      }
    } else if (originalGroupType === 'family_one_adult') {
      if (key === 'family_one_adult' || key === 'family' || key === 'group') {
        return this.renderGroupTypes(name, key);
      }
    } else if (originalGroupType === 'group') {
      if (key === 'group') {
        return this.renderGroupTypes(name, key);
      }
    }
  }

  private renderGroupTypes = (name, key) => {
    const { i18n, formValues, change } = this.props;
    const groupType = formValues.metadata.traveller_group;
    const premium = head(get(formValues, 'premiums', []))
    const hasGroup = get(premium, 'information.hasGroups', false)

    if (groupType !== 'group' && !hasGroup && key === 'group') {
      return null;
    }

    if (key === 'family_one_adult' || key === 'individual') {
      return;
    }

    const selected = groupType === key || (key === 'family' && groupType === 'family_one_adult');

    const onGroupTypeChange = () => {
      change('data.attributes.metadata.traveller_group', key);
      this.setState({ showTravellers: true })
    }

    const getImage = () => {
      switch (key) {
        case 'individual':
          return QuoteIcons({ name: 'Person', color: 'darkBlue' });
        case 'couple':
          return QuoteIcons({ name: 'Couple', color: 'darkBlue' });
        case 'family':
          return QuoteIcons({ name: 'Family', color: 'darkBlue' });
        case 'group':
          return QuoteIcons({ name: 'Group', color: 'darkBlue' });
        default:
          return (<></>);
      }
    }

    return (
      <div
        key={key}
        className={selected ? 'group-type-selection-container selected' : 'group-type-selection-container'}
        onClick={onGroupTypeChange}
      >
        <div>{getImage()}</div>
        <div className={'group-type-description-container'}>
          <span className={'group-type-name'}>{name}</span>
          <div className={'group-type-subtext'}>
            {i18n.quote.tripDetails.groupTypeDescriptions[key]}
          </div>
        </div>
      </div>
    );
  }

  /**
   * Check whether any of the travellers fail DOB validation
   * @private
   */
  private checkForDobErrors() {
    const { travellers, groupType } = this.props;
    let error = '';
    const isGroup = groupType === 'group'

    travellers.forEach(traveller => {
      if (!traveller.dob) {
        return
      }
      const dob = traveller.dob;
      error = (traveller.type === 'adult')
        ? isAdult(dob)
        : isDobAFutureDate(dob) || (isGroup ? isGroupChild(dob) : isChild(dob));
    })

    return !!error;
  }

  public render() {
    const {
      handleSubmit, i18n, actions, mta, tripType, change,
      submitFailed, submitting, valid, groupType, travellers, selectedPolicy,
    } = this.props;
    const product = actions.branding.getProduct();
    const renderDefinition = renderProductDefinition(product);
    const hasDobErrors = this.checkForDobErrors()

    const submitButton = (
      <Button
        bsStyle="primary"
        type="submit"
        bsSize="small"
        className="medium-width pull-right secondary-button"
        disabled={hasDobErrors || submitting || (submitFailed && !valid ||
          !valid || selectedPolicy.travellers.length === travellers.length)}
      >
        CONTINUE
      </Button>
    );

    const goBackButton = (
      <Link to="/account/summary">
        <Button
          bsStyle={'primary'}
          className={'secondary-button'}>
          GO BACK
        </Button>
      </Link>
    );
    return (
      <>
        <Form horizontal={true} onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off"
              style={{ marginTop: '15px' }}>
          <div className="admiral-card" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div className={'p-details-overview-header'}>
              <div className={'p-d-overview-icon'}>
                <img height={'36px'} style={{ marginRight: '10px' }}
                     src={require('../../../../../../../CustomerAreaNew/scenes/MakeAChange/Images/add-user.svg')}
                     alt={'Add traveller icon'}/>
              </div>
              <div>
                <div className={'p-d-overview-text'}>
                  Update the travellers on the policy
                </div>
                <div>Answer the below questions and click continue</div>
              </div>
            </div>
            <div className="body">
              <div className="container-fluid">
                <Grid fluid={true}>
                  <div style={{ margin: '0 0 20px 0' }}>
                    <div style={{ marginTop: '20px' }} className="mta-declaration-body-text">Who will be travelling?
                    </div>
                    <div style={{ marginTop: '20px' }}>
                      {map(product.metadata[`group_type_trip_${tripType}`], (name, key) => {
                        return this.allowedGroupTypes(name, key);
                      })}
                    </div>
                    {this.state.showTravellers &&
                      <FieldArray
                        name="data.attributes.travellers"
                        i18n={i18n}
                        product={product}
                        component={MTATravellers}
                        groupType={groupType}
                        renderDefinition={renderDefinition}
                        change={change}
                        isRenewal={false}
                      />
                    }
                  </div>
                </Grid>
              </div>
            </div>
          </div>

          <div style={{ maxWidth: '800px', margin: '10px auto' }}>
            <MTAButtons button1={goBackButton} button2={submitButton}/>
          </div>

        </Form>
      </>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);
    return component;
  },
  connect(
    (state: IStore) => {
      const options = selector(state, 'data.attributes.metadata.options');
      const tripType = selector(state, 'data.attributes.metadata.scheme_type');
      const groupType = selector(state, 'data.attributes.metadata.traveller_group');
      const travellers = selector(state, 'data.attributes.travellers');
      const visibility = selector(state, 'visibility');
      const values = selector(
        state,
        'data.attributes',
      );
      return {
        mta: state.mta,
        selectedPolicy: state.mta.selectedPolicy,
        options,
        i18n: state.branding.i18n,
        visibility,
        formValues: values,
        tripType,
        groupType,
        travellers,
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(MTAAdditionalTravellersForm);
